import { render, staticRenderFns } from "./CompanyProfileEvents.vue?vue&type=template&id=1cdc8d88"
import script from "./CompanyProfileEvents.vue?vue&type=script&lang=js"
export * from "./CompanyProfileEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports